<template>
  <div class="Detail centre">
    <Breadcrumb :breadList="breadList"></Breadcrumb>
    <div class="book-detail">
      <div class="book-intro">
        <div class="intro-box">
          <div class="intro-content">
            <div class="picture" :style="'background: url('+ picUrl +') no-repeat top center /cover'"></div>
            <div class="book-text">
              <h3>{{title}}</h3>
              <div class="book-introduce">
                <b>书籍简介</b>
                <p>{{introduce}}</p>
              </div>
            </div>
          </div>
          <el-button class="clickBook" @click="clickBook(bookId, 1)" :disabled="likeBookPermission">
            {{likeBookPermission ? '暂未开放' : '开始阅读'}}
          </el-button>
          <el-button class="collectBtn" @click="collection">{{collectionShow ? '已收藏' : '收藏'}}</el-button>
        </div>
        <div class="book-menu">
          <h3>册次及目录</h3>
          <div v-if="menuList.length <= 0">
            <el-empty description="暂无目录" style="padding:0"></el-empty>
          </div>
          <div class="detail-menu-box" v-else v-for="item in menuList">
            <div class="menu-node" @click="item.show = !item.show">
              <span @click="clickBook(item.bookId, 1)">{{toStr(item.bookName)}}</span>
              <span class="detail-menu-view-page" @click="clickBook(item.bookId, 1)">第{{item.volumeNum}}册</span>
            </div>
            <div class="menu-children-box" v-show="item.show">
              <div class="menu-children-node" v-for="chd in item.catalogues"
                   @click="clickBook(chd.bookId, chd.page)">
                <span>{{toStr(chd.description)}}</span>
                <span class="detail-menu-view-page">第{{chd.page}}页</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="detailIntro">
        <div class="detailTitle">
          <h2>{{title}}</h2>
        </div>
        <div class="detailList">
          <ul :title="title">
            <li v-for="(item, index) in itemList" v-if="item.attributeValue" :class="tableRowClassName(index)">
              <p>{{item.captions}}</p>
              <p>{{item.attributeValue}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="hotbook">
      <div class="hotbook-title">
        <p>推荐书籍</p>
        <div @click="updateBtn">
          <img src="../../assets/img/library/xcvxc.png" alt=""/>
          <span>换一换</span>
        </div>
      </div>
      <!-- 热门推荐 -->
      <div class="hot-box">
        <div v-if="!hotList || hotList.length <= 0" class="empty">
          <el-empty description="暂无推荐"></el-empty>
        </div>
        <div
          class="hot-list"
          v-for="(item, index) in hotList"
          :key="index"
          v-if="index < 6"
          @click="setHootBookId(item)"
        >
          <div
            class="detail-hot-picture"
            v-if="item.coverPic"
            :style="'background: url(' +item.coverPic +') no-repeat top center /cover'"></div>
          <div class="detail-hot-picture " v-else></div>
          <div class="detail-hot-name">{{ toStr(item.bookName) }}</div>
          <div class="detail-hot-author">{{ toStr(item.author) }}</div>
        </div>
      </div>
    </div>
    <UserLogin ref="UserLogin"/>
  </div>
</template>

<script>
  import Breadcrumb from "../../components/Breadcrumb.vue";
  import UserLogin from '@/components/login/UserLogin.vue'
  import {
    getHistoryOrder,
    getBookById,
    addCollection,
    getMasterSlaveCatalogue,
    deleteCollectionById,
    addReadHistory,
    getBookStatusByBookId
  } from "../../utils/router/detail.api";

  export default {
    name: "Detail",
    data() {
      return {
        //面包屑
        breadList: [
          {title: "在线书库", path: "/library"},
          {title: "查看详情", path: this.$route.path},
        ],
        menuList: [],
        typeId: this.$store.state.typeId,
        loginState: '',
        picUrl: 'img/default.jpg',
        //是否开放
        likeBookPermission: false,
        title: '',
        author: '',
        itemList: {},
        hotList: [],
        bookId: '',
        // 书目录
        menuList: [],
        introduce: '暂无简介',
        //收藏
        collectionShow: false,
        collectionId: '',
        link: location.href,
        hotPage: 1,
      };
    },
    methods: {
      tableRowClassName(rowIndex) {
        if (rowIndex % 2 == 1) {
          return 'warning-row';
        }
        return '';
      },
      updateBtn(item) {
        this.hotPage++
        this.getHot()
      },
      clickBook(id, page) {
        if (!this.loginState) {
          this.$confirm('请登录 ').then(_ => {
            this.$refs.UserLogin.openDialog(false)
          })
          return
        }
        this.addRead()
        //打开一个不被拦截的新窗口
        var newWindow = window.open();
        this.goToRead(id, page, newWindow)
      },
      goToRead(id, page, newWindow) {
        let url = "/frontend/viewer.html?typeId=" + this.$store.state.typeId + "&bookId=" + id + "#page=" + page + "&viewer=picture";
        newWindow.location.href = url;
      },
      toStr(val) {
        return val ? val.toString() : "无";
      },
      // 基本信息
      baseInfo() {
        getBookById({
          bookId: this.bookId
        }).then(res => {
          if (res && res.data.data) {
            //获取 读者页面显示的字段和值
            this.itemList = Object.freeze(res.data.data)
            if (this.itemList.length > 0) {
              this.itemList = this.itemList.filter(data => {
                //去掉不需要显示的字段 value
                let value = data
                data.captions.indexOf("题名") >= 0 && (this.title += data.attributeValue + ' ')
                if (data.captions == 'coverPicture' && data.attributeValue) {
                  data.attributeValue.length > 5 && (this.picUrl = data.attributeValue)
                  value = ''
                }
                data.captions == "简介" && (this.introduce = data.attributeValue + ' ', value = '')
                data.captions == "是否公开" && (this.likeBookPermission = (data.attributeValue == '否' || data.attributeValue == 'no'), value = '')
                return value != ''
              })

            }

            this.getMenu()
            this.getHot()
            this.getCollection()
            this.$store.state.userInfo.userId && this.addRead()
          }
        })
      },
     // 新增浏览
      addRead() {
        addReadHistory({
          userId: this.$store.state.userInfo.userId,
          bookId: this.bookId,
          typeId: this.typeId,
          bookName: this.title,
          userName: this.$store.state.userInfo.userName,
        }).then(res => {
          if (res && res.data) {
            //浏览记录 添加成功
          }
        })
      },
      //添加收藏
      collection() {
        if (!this.loginState) {
          this.$confirm('请登录 ').then(_ => {
            this.$refs.UserLogin.openDialog(false)
          })
          return
        }
        if (!this.collectionShow) {
          addCollection({
            bookId: this.bookId,
            typeId: this.$store.state.typeId,
            userId: this.$store.state.userInfo.userId,
            userName: this.$store.state.userInfo.userName,
          }).then(res => {
            if (res && res.data.code == 200) {
              this.collectionShow = true
            }
          })
        } else {
          //取消
          deleteCollectionById({
            bookId: this.bookId,
            userId: this.$store.state.userInfo.userId,
          }).then(res => {
            if (res && res.data.code == 200) {
              this.collectionShow = false
            }
          })
        }
      },
      //收藏
      getCollection() {
        if (!!this.$store.state.userInfo.userId) {
          getBookStatusByBookId({
            userId: this.$store.state.userInfo.userId,
            bookId: this.bookId
          }).then(res => {
            if (res && res.data.data) {
              if (!!res.data.data) {
                this.collectionShow = true
                this.collectionId = res.data.data
              }
            }
          })
        }
      },
      //热书推荐 点击
      setHootBookId(item) {
        this.$router.push({
          path: '/detail',
          query: {
            key: this.$UrlEncode.encode(JSON.stringify({
              bookId: item.bookId
            }))
          }
        })
        location.reload();
      },
      //获取热门推荐
      getHot() {
        getHistoryOrder({
          typeId: this.$store.state.typeId,
          page: this.hotPage,
          limit: 6,
        }).then((res) => {
          if (res && res.data.data) {
            this.hotList = res.data.data;
            this.hotList = this.hotList.map((data) => {
              if (!data.coverPic || data.coverPic == "/") {
                data.coverPic = "/frontend/img/default.jpg";
              }
              return data;
            });
            res.data.data.length < 6 && (this.hotPage = 0)
          }

        });
      },
      //获取套书目录
      getMenu() {
        getMasterSlaveCatalogue({
          bookId: this.bookId,
          typeId: this.$store.state.typeId
        }).then(res => {
          if (res && res.data.data) {
            this.menuList = res.data.data.map(data => {
              data.bookId == this.bookId ? data.show = true : data.show = false
              return data
            })
          }
        })
      },
    },
    created() {
      //登录
      if (sessionStorage.getItem('portal_user_info')) {
        this.loginState = JSON.parse(sessionStorage.getItem('portal_user_info'));
      }
      //获取书籍id
      const id = JSON.parse(this.$UrlEncode.decode(this.$route.query.key)) || ''
      id ? this.bookId = id.bookId : this.$router.push("library")
      this.baseInfo()
    },
    components: {
      Breadcrumb,
      UserLogin
    },
  };
</script>

<style lang="less" scoped>
  .Detail {
    background: #fff;
    padding: 0 52px;
    padding-bottom: 52px;

    .book-detail {
      min-height: 652px;
      border: 1px solid #bfbfbf;
      box-shadow: 0px 4px 7px 0px rgba(6, 0, 1, 0.1);
      display: flex;
      padding: 30px 26px 0px 30px;

      .book-intro {
        flex: 1;

        .intro-box {
          border-bottom: 3px solid #d6d6d6;
          padding-bottom: 16px;
          margin-right: 26px;

          .intro-content {
            display: flex;
            margin-bottom: 42px;

            .picture {
              width: 172px;
              height: 218px;
              // background-image: url('../../assets/img/library/book.png');
            }

            .book-text {
              color: #242424;
              font-size: 22px;
              flex: 1;
              padding-left: 34px;
            }

            .book-introduce {
              font-size: 18px;
              padding: 30px 0px;

              p {
                width: 100%;
                text-align: center;
                margin-top: 10px;
                font-size: 16px;
              }
            }
          }

          .el-button {
            height: 48px;
            background-color: #654719;
            color: #fff;
            font-size: 20px;
          }

          .clickBook {
            width: 356px;
            border-radius: 6px;
          }

          .collectBtn {
            width: 172px;
            float: right;
          }
        }

        .book-menu {
          min-height: 266px;
          color: #242424;
          font-size: 20px;
          margin: 6px 26px 20px 0px;
          overflow: hidden;

          h3 {
            line-height: 50px;
          }

          .detail-menu-box {
            line-height: 44px;

            .menu-node {
              background-color: #f5f5f5;
              padding-left: 20px;
              border-bottom: solid 3px #fff;
              cursor: cell;

              span {
                cursor: pointer;
              }
            }

            .menu-node:hover {
              background-color: #e0dad1;
            }

            .menu-children-node {
              border-bottom: solid 1px #f5f5f5;
              padding-left: 50px;
              cursor: pointer;
            }

            .detail-menu-view-page {
              float: right;
              font-size: 12px;
              color: #888;
              margin-right: 20px;
            }

            .menu-children-node:hover {
              color: #654719;
              background-color: #ffedd3;
            }
          }
        }
      }

      .detailIntro {
        width: 427px;
        background: url("../../assets/img/library/border.png") no-repeat;
        background-size: 100% 100%;
        color: #242424;
        margin-left: 10px;
        padding: 28px 44px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .detailTitle {
          border-bottom: 3px solid #d6d6d6;
          display: flex;
          margin: 14px 0;
          line-height: 42px;
          padding-left: 10px;

          h2:first-child {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          h2:last-child {
            flex: 1;
          }
        }

        .detailList {
          li {
            display: flex;
            font-size: 18px;
            line-height: 40px;
            padding-left: 10px;

            p {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          /deep/ .warning-row {
            background: #f2ece5;
          }
        }
      }
    }

    .hotbook {
      height: 472px;
      border: 1px solid #bfbfbf;
      box-shadow: 0px 4px 7px 0px rgba(6, 0, 1, 0.1);
      color: #242424;
      margin-top: 20px;
      padding: 20px 26px;

      .hotbook-title {
        font-size: 22px;
        border-bottom: 3px solid #d6d6d6;
        display: flex;
        line-height: 42px;
        padding-bottom: 10px;

        p {
          flex: 1;
          font-weight: bold;
        }

        div {
          cursor: pointer;

          img {
            width: 30px;
            height: 30px;
            position: relative;
            top: 8px;
          }
        }
      }

      .hot-box {
        color: #242424;
        display: flex;
        flex-wrap: wrap;
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
        margin-top: 18px;

        .hot-list {
          width: 178px;
          height: 330px;
          margin-right: 26px;
          padding: 10px;
          cursor: pointer;

          .detail-hot-picture {
            width: 158px;
            height: 254px;
            background-image: url('../../assets/img/library/book.png');
          }

          .detail-hot-author {
            font-size: 14px;
            padding-top: 10px;
          }
        }

        .hot-list:hover {
          background-color: #e0dad1;
        }
      }

      .empty {
        margin: auto;
      }
    }
  }
</style>
